/**
 * 趣味关系详情
 * */
import React, { useEffect, useState, useRef } from 'react';
import { Modal } from 'antd';
import './InterestAffinityDetailModal.scss';
import Util from '../../../script/util';
import InterestAffinityAvatar from './InterestAffinityAvatar';
import WebglVideo from '../../../components/webglVideo/indexNew';

let svgaPlayer, svgaParser;
const InterestAffinityDetailModal = ({ visible, data, onClose }) => {
  const [detail, setDetail] = useState(null);
  const [playEnd, setPlayEnd] = useState(false);
  const effectsTime = useRef(null);
  const effectBox = useRef(null);
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (visible && data) {
      setDetail(data);
    }
    return () => {
      svgaPlayer?.destroy && svgaPlayer.destroy();
      if (svgaPlayer?.stopAnimation) {
        svgaPlayer.stopAnimation();
        svgaPlayer.clear();
        svgaPlayer.clearDynamicObjects();
      } else if (svgaPlayer?.stop) {
        svgaPlayer.stop();
      }
      svgaPlayer = null;
      clearTimeout(effectsTime.current);
      setPlayEnd(false);
      setDetail(null);
    };
  }, [visible]);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (detail && visible) {
      handleEffects();
    }
  }, [detail]);

  const handleEffects = () => {
    const isSeniorEffects =
      detail?.effectPicPc?.indexOf('.svga') > -1 ||
      detail?.effectPicPc?.indexOf('.mp4') > -1 ||
      false;
    if (isSeniorEffects && visible) {
      setPlayEnd(false);
      if (detail?.effectPicPc.indexOf('.svga') > -1) {
        // SVGA 素材单独处理
        if (!window._SVGA) return;
        effectsTime.current = setTimeout(() => {
          svgaPlayer = new window.SVGA.Player('#propBox');
          svgaParser = new window.SVGA.Parser('#propBox');
          svgaPlayer.fillMode = 'Forward'; // 停留在最后一帧
          svgaPlayer.clearsAfterStop = false;
          // 初始化SVGA
          svgaParser.load(
            Util.transImgUrl(detail?.effectPicPc),
            (videoItem) => {
              if (visible) {
                svgaPlayer.loops = 1; // 播放次数
                svgaPlayer.setVideoItem(videoItem);
                svgaPlayer.startAnimation();

                setTimeout(() => {
                  setPlayEnd(true);
                }, 500);
              }
            }
          );
        }, 200);
      } else if (detail?.effectPicPc.indexOf('.mp4') > -1) {
        effectsTime.current = setTimeout(async () => {
          svgaPlayer = await WebglVideo({
            container: effectBox.current,
            src: Util.transImgUrl(detail?.effectPicPc),
            loop: false,
            endPause: true,
            onStart: () => {
              setTimeout(() => {
                setPlayEnd(true);
              }, 500);
            },
          });
        }, 200);
      }
    }
  };
  return (
    <div className="affinity-modal">
      <Modal
        open={visible}
        zIndex={1003}
        style={{ overflow: 'hidden' }}
        className="daidai-modal-invitation "
        closable={false}
        centered={true}
        footer={null}
        destroyOnHidden
        keyboard={false}
        maskClosable={true}
        width="400px"
      >
        <div className={`interest-affinity-detail-modal`}>
          <div
            className="interest-affinity-detail-effect"
            id="propBox"
            ref={effectBox}
          ></div>
          <div
            className="interest-affinity-detail-close"
            onClick={onClose}
          ></div>
          {playEnd ? (
            <div className="interest-affinity-detail-avatar">
              <InterestAffinityAvatar
                style={{ width: '100%' }}
                data={detail}
                showName={true}
              />
            </div>
          ) : null}
        </div>
      </Modal>
    </div>
  );
};
export default InterestAffinityDetailModal;
